import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  DatePicker,
  Radio,
  Input,
  Table,
  Modal,
  Popover,
  Checkbox,
  Divider,
  Select,
  Popconfirm,
  Pagination,
  Tooltip,
  InputNumber,
  Form,
  Switch,
} from "antd";
import moment from "moment";
import _ from "underscore";
import { app } from "../../app";
import TeamSeleted from "../../components/TeamSeleted";
import Card from "../../components/Card";
import TaskAdd from "./TaskAdd1";
import date_locale from "antd/lib/date-picker/locale/zh_CN";
import api from "../../api";
import utils from "../../utils";
import ReportDration from "./ReportDration";
import config from "../../config";
import WhiteList from "./WhiteList";
import common from "./common";
import common2 from "./common2";
import "../../css/sign-report-add.css";
import { set } from "echarts-gl";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const Option = Select.Option;
const { RangePicker } = DatePicker;
const CheckboxGroup = Checkbox.Group;
const FormItem = Form.Item;

class SignReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      select_team: {},
      select_tab: "2",
      page: 1,
      page2: 1,
      total: 0,
      total2: 0,
      type: -1,
      publish_status: -1,
      edit_modal: false,
      edit_modal2: false,
      detail_visible: false,
      white_modal: false,
      duration_modal: false,
      edit_id: null,
      dataList: [],
      dataList2: [],
      teamList: [],
      exportDate: [],
      checkedList: [],
      PositionList: [],
      detail_data: {},
      news_imgs: [],
      indeterminate: false,
      multiple_duration: 0,
      checkAll: false,
      export_visible: false,
      search_content: "",
      isCur: true,
      isCur2: true,
      editList: [],
      selectedRowKeys: [],
      edit_type: -1,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.ClassList();
    this.handleReportsData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

   /**
   * 获取报表列表
   * @returns {Promise<void>}
   */
   handleReportsData = async (team_id, page) => {
    await this.setData({ page, data_loading: true });
    this.state.dataList = [];
    let { start_time, end_time, search_content, type, publish_status } = this.state,
      params = {
        start_time,
        end_time,
        type,
        publish_status,
        page: page || 1,
        teamno: this.state.select_team.teamno,
        team_id: team_id,
        ally_way: 2,
        search_content,
        account: app.getData("account"),
        indexno: app.getData("indexno"),
      },
      { flag, data, msg, total } = await app.post(api.ReportstaskList, params);
    if (flag !== 1) {
      app.alert(msg, "error");
      data = [];
    }
    if (page === this.state.page) {
      await this.setData({
        dataList: utils.addArrayKey(data),
        data_loading: false,
        total: Number(total || 0),
      });
    }
  };


  /**
   * 获取报表记录列表
   * @returns {Promise<void>}
   */
  handleReportsRecordData = async (page = 1, team_id) => {
    await this.setData({ page, data_loading: true });
    let { select_team, search_content } = this.state,
      params = {
        page,
        search_content,
        team_id: team_id,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg, total } = await app.post(
        api.ReportsOperateList,
        params
      );
    if (flag !== 1) {
      app.alert(msg, "error");
      data = [];
    }
    if (page === this.state.page) {
      await this.setData({
        dataList: utils.addArrayKey(data),
        data_loading: false,
        total: Number(total || 0),
      });
    }
  };

  /**
   * 选择队伍
   */
  handleSelectTeam = async (team, index, teamList) => {
    await this.setData({ select_team: team, teamList });
    let { select_tab } = this.state;
    if (select_tab === "1") {
      await this.handleReportsRecordData();
    } else if (select_tab === "2") {
      await this.handleReportsData(team.team_id);
    }
  };

  // 任务类型
  ClassList = async () => {
    let params = {
        account: app.getData("account"),
        indexno: app.getData("indexno"),
      },
      { flag, data, msg } = await app.post(api.ReportsOption, params);
    if (flag === 1) {
      this.setData({ PositionList: data.type });
    } else {
      app.alert(msg, "error");
      return {};
    }
  };

  /**
   * 日期筛选变更
   * @param date
   */
  handleDateChange = async (date) => {
    if (date.length > 1) {
      await this.setData({
        start_time: date[0].format("YYYY-MM-DD"),
        end_time: date[1].format("YYYY-MM-DD"),
      });
    } else {
      await this.setData({ start_time: null, end_time: null });
    }
    await this.handleReportsData();
  };

  /**
   * Tab筛选变更
   * @param e
   */
  handleTabChange = async (e) => {
    let { value } = e.target;
    await this.setData({ select_tab: value, total: 0, dataList: [] });
    switch (value) {
      case "1":
        await this.handleReportsRecordData();
        break;
      case "2":
        await this.handleReportsData();
        break;
    }
  };

  // 修改保密
  confidentiality = async (e, task_id) => {
    if (e == 0) {
      let { flag, data, msg, total } = await app.post(api.taskSecretstatus, {
        task_id,
        secret: 1,
        account: app.getData("account"),
        indexno: app.getData("indexno"),
      });
      if (flag === 1) {
        await this.handleReportsData();
      } else {
        app.alert(msg, "error");
      }
    } else if (e == 1) {
      let { flag, data, msg, total } = await app.post(api.taskSecretstatus, {
        secret: 0,
        task_id,
        account: app.getData("account"),
        indexno: app.getData("indexno"),
      });
      if (flag === 1) {
        await this.handleReportsData();
      } else {
        app.alert(msg, "error");
      }
    }
  };

  /**
   * 打开编辑框
   * @param e
   */
  handleOpenEditModal = (select_team, edit_id) => {
    this.setData({ edit_modal: true, select_team, edit_id, isDo: false });
  };
  /**
   * 打开报名信息
   * @param e
   */
  handleOpenEditModal2 = async (task_id, page) => {
    this.setData({ edit_modal2: true });
    let { page2 } = this.state;
    this.state.dataList2 = [];
    let { flag, data, msg, total } = await app.post(api.taskSeLectApplyInfo, {
      task_id,
      page: page || page2,
      account: app.getData("account"),
    });
    if (flag === 1) {
      await this.setData({
        task_id: task_id,
        dataList2: utils.addArrayKey(data),
        total2: Number(total || 0),
        task_id,
        data_loadings: false,
      });
    } else {
      app.alert(msg, "error");
    }
  };
  /**
   * 关闭编辑框
   */
  handleCloseEditModal = async (flush) => {
    let { select_team } = this.state;
    if (flush === true) {
      await this.setData({
        select_tab: "2",
        total: 0,
        dataList: [],
        edit_modal: false,
      });
      await this.handleReportsData(select_team.team_id);
    } else {
      await this.setData({ edit_modal: false });
    }
  };
  /**
   * 关闭报名信息
   */
  handleCloseEditModal2 = async (flush) => {
    this.setState({
      edit_modal2: false,
      selectedRowKeys: [],
      isCur: true,
      isCur2: true,
      multiple_duration: 0,
    });
  };

  /**
   * 今天没有任务按钮
   */
  handleReportsTask = async () => {
    let { select_team } = this.state,
      params = {
        teamno: select_team.teamno,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, msg } = await app.post(api.ReportsTask, params);
    if (flag === 1) {
      app.alert(msg, "success");
    } else {
      app.alert(msg, "warn");
    }
  };

  /**
   * 跳转签到
   */
  handleSign = () => {
    this.props.history.push("/sign");
  };

  /**
   * 打开时长管理
   */
  handleOpenDurationModal = (id) => {
    this.setData({ duration_id: id, duration_modal: true });
  };

  /**
   * 关闭时长管理
   */
  handleCloseDurationModal = () => {
    this.setData({ duration_id: null, duration_modal: false });
  };

  /**
   * 打开白名单
   */
  handleOpenWhiteModal = (id) => {
    this.setData({ white_modal: true });
  };

  /**
   * 关闭报名信息详情
   */
  handleCancelDetail = () => {
    this.setData({ detail_visible: false, news_imgs: [] });
  };
  /**
   * 关闭图片
   */
  handleCancelDetails = () => {
    this.setData({ img_visible: false });
  };
  /**
   * 编辑
   * @param edit_id
   */
  handleEdit = async (edit_id, isDo) => {
    this.setData({
      edit_modal: true,
      team_id: this.state.select_team.team_id,
      teamname: this.state.select_team.teamname,
      edit_id,
      isDo: isDo,
    });
  };

  // 开始任务/结束任务
  operation = async (task_id, status) => {
    let { select_team } = this.state;
    let { flag, data, msg } = await app.post(api.taskStatusSave, {
      task_id,
      status,
      account: app.getData("account"),
    });
    if (flag === 1) {
      app.alert(msg, "success");
      await this.handleReportsData(select_team.team_id);
    } else {
      app.alert(msg, "error");
    }
  };
  /**
   * 打开详情
   */
  handleOpenDetail = async (record_id) => {
    await this.setData({ detail_visible: true, detail_loading: true });
    let state = { detail_loading: false };
    let { news_imgs } = this.state;
    let { flag, data, msg } = await app.post(api.taskApplyInfoDetails, {
      record_id,
      account: app.getData("account"),
    });
    if (flag === 1) {
      state.detail_data = data;
      if (data.live_images && data.live_images.includes(":::")) {
        // 如果字符串中包含双冒号，进行分割操作并将结果存入 news_imgs 数组中
        news_imgs = data.live_images.split(":::");
      } else if (data.live_images) {
        // 如果字符串中不包含双冒号，将该字符串直接添加到 news_imgs 数组中
        news_imgs.push(data.live_images);
      }
      this.setData({ detail_data: data, news_imgs });
    } else {
      app.alert(msg, "error");
    }
    await this.setData(state);
  };

  repair = async (user_id) => {
    this.setData({ repair_visible: true, userIds: user_id });
  };

  /**
   * 删除
   * @param id
   */
  handleDelete = async (task_id) => {
    let { flag, msg } = await app.post(api.delTask, {
      task_id: task_id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    });
    if (flag === 1) {
      app.alert("删除成功", "success");
      const { page, total } = this.state;
      let tp = parseInt((total - 1) / 20);
      tp = (total - 1) % 20 === 0 ? tp : tp + 1;
      if (tp >= page) {
        tp = page;
      }
      let { select_team } = this.state;

      await this.handleReportsData(select_team.team_id);
    } else {
      app.alert(msg, "error");
    }
  };

  /**
   * 关闭时白名单
   */
  handleCloseWhiteModal = () => {
    this.setData({ white_modal: false });
  };

  /**
   * 导出队伍选择
   * @param checkedList
   */
  handleExportCheckChange = (checkedList) => {
    const { teamList } = this.state;
    this.setData({
      checkedList,
      indeterminate:
        !!checkedList.length && checkedList.length < teamList.length,
      checkAll: checkedList.length === teamList.length,
    });
  };

  /**
   * 导出队伍全选
   * @param e
   */
  handleExportCheckAll = (e) => {
    const { teamList } = this.state;
    this.setData({
      checkedList: e.target.checked ? teamList.map((team) => team.teamno) : [],
      indeterminate: false,
      checkAll: e.target.checked,
    });
  };

  // 去搜索
  toSearchBtn = () => {
    this.setData({ page: 1 });
    const { select_team, load_index } = this.state;
    this.handleReportsData(select_team.team_id);
  };
  // 改变页码
  changeAhegp = (q) => {
    let { page, task_id } = this.state;
    page = q;
    this.setState({ page: q });
    const { select_team } = this.state;
    this.handleReportsData(select_team.team_id, page);
  };
  // 改变页码
  changeAhegp2 = (q) => {
    let { page2, task_id } = this.state;
    page2 = q;
    this.setState({ page2: q });
    this.handleOpenEditModal2(task_id, page2);
  };
  // 修改任务时长
  amend_duration = () => {
    let { task_id } = this.state;
    this.state.dataList2 = [];
    this.state.editList = [];
    this.setState({
      isCur: false,
      isCur2: true,
      multiple_duration: 0,
      data_loadings: true,
    });
    this.handleOpenEditModal2(task_id);
  };
  // 修改任务积分
  amend_integral = () => {
    let { task_id } = this.state;
    this.state.dataList2 = [];
    this.state.editList = [];
    this.setState({
      isCur2: false,
      isCur: true,
      multiple_duration: 0,
      data_loadings: true,
    });
    this.handleOpenEditModal2(task_id);
  };
  /**
   * 全选
   * @param e
   */
  handleAllSel = (e) => {
    let checked = e.target.checked;
    let selectedRowKeys = [];
    if (checked) {
      selectedRowKeys = _.range(1, this.state.dataList2.length + 1);
    }
    this.setData({ selectedRowKeys });
  };
  /**
   * 多个设置编辑列表
   */
  handleMultipleSetEditList = async (duration, keys) => {
    let { isCur, isCur2 } = this.state;
    if (duration && !isCur) {
      let { dataList2 } = this.state;
      await this.setData({ dataList2: [] });
      for (let i = 0; i < keys.length; i++) {
        let data = dataList2[keys[i] - 1];
        data.task_duration = duration;
        this.handleSetEditList(data.user_id, data.task_duration);
      }
      await this.setData({ dataList2 });
    }
    if (duration && !isCur2) {
      let { dataList2 } = this.state;
      await this.setData({ dataList2: [] });
      for (let i = 0; i < keys.length; i++) {
        let data = dataList2[keys[i] - 1];
        data.task_integral = duration;
        this.handleSetEditList(data.user_id, data.task_integral);
      }
      await this.setData({ dataList2 });
    }
  };
  // 批量补卡
  handleMultipleSetEditList2 = async (keys) => {
    let { dataList2 } = this.state;
    await this.setData({ dataList2: [] });
    const editList = [];
    for (let i = 0; i < keys.length; i++) {
      let data = dataList2[keys[i] - 1];
      editList.push({ user_id: data.user_id });
    }
    const userIds = editList.map((user) => user.user_id).join(",");
    await this.setData({ dataList2, repair_visible: true, userIds });
  };
  // 监听输入
  inputMotify = (e) => {
    // search_value
    this.setState({
      search_content: e.target.value,
    });
  };
  /**
   * 任务时长设置
   */
  handleSetEditList = (user_id, val) => {
    const { editList } = this.state;
    let index = editList.findIndex((e) => e.user_id === user_id);
    if (index !== -1) {
      editList[index].val = val;
    } else {
      editList.push({ user_id, val });
    }
  };
  /**
   * 保存
   */
  handleConfirm = async () => {
    let { editList } = this.state;
    if (editList.length > 0) {
      await this.setData({ submit_loading: true });
      let { task_id, isCur, isCur2 } = this.state,
        params = {
          task_id,
          edit_type: isCur == false ? "1" : isCur2 == false ? "2" : "",
          str: JSON.stringify(editList),
          account: app.getData("account"),
        };
      let { flag, msg } = await app.post(api.durationEdit, params);
      await this.setData({ submit_loading: false });
      if (flag === 1) {
        app.alert("修改成功", "success");
        this.setState({
          selectedRowKeys: [],
          isCur: true,
          isCur2: true,
          multiple_duration: 0,
          data_loadings: true,
        });
        let { task_id } = this.state;
        this.state.dataList2 = [];
        this.state.editList = [];
        this.handleOpenEditModal2(task_id);
      } else {
        app.alert(msg, "error");
      }
    } else {
      this.setState({
        selectedRowKeys: [],
        isCur: true,
        isCur2: true,
        multiple_duration: 0,
        data_loadings: true,
      });
      let { task_id } = this.state;
      this.state.dataList2 = [];
      this.state.editList = [];
      this.handleOpenEditModal2(task_id);
    }
  };

  /**
   * 打开修改记录
   */
  handleOpenRecord = async () => {
    this.state.record_modal = true;
    await this.handleRecordData();
  };

  /**
   * 关闭修改记录
   */
  handleCloseRecord = () => {
    this.setData({ record_modal: false });
  };
  /**
   * 记录列表
   * @param rpage
   * @returns {Promise<void>}
   */
  handleRecordData = async (rpage = 1) => {
    await this.setState({ rpage, record_loading: true });
    let { task_id, edit_type } = this.state,
      params = {
        task_id,
        edit_type,
        page: rpage,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      };
    let { flag, data, msg, total } = await app.post(
      api.durationEditRecord,
      params
    );
    if (flag !== 1) {
      app.alert(msg, "error");
      data = [];
    }
    if (rpage === this.state.rpage) {
      await this.setData({
        record_loading: false,
        recordList: utils.addArrayKey(data),
        rtotal: parseInt(total || 0),
      });
    }
  };
  /**
   * 导出
   * @returns {Promise<void>}
   */
  handleExport = async () => {
    let { checkedList, exportDate } = this.state;
    let params = [
      `token=${app.getToken()}`,
      `indexno=${app.getData("indexno")}`,
      `account=${app.getData("account")}`,
    ];
    if (exportDate.length === 2) {
      params.push(
        `start_time=${exportDate[0].format("YYYY-MM-DD")}`,
        `end_time=${exportDate[1].format("YYYY-MM-DD")}`
      );
    }
    if (checkedList.length > 0) {
      params.push(`teamno=${checkedList.join(",")}`);
    } else {
      app.alert("请选择导出队伍", "warn", "10%");
      return;
    }
    let url = config.serverUrl + api.ReportsExport + "?" + params.join("&");
    app.downFile(url);
    app.alert("导出成功", "success", "10%");
    await this.setData({
      exportDate: [],
      checkedList: [],
      indeterminate: false,
      checkAll: false,
      export_visible: false,
    });
  };

  render() {
    let {
        white_modal,
        select_team,
        select_tab,
        data_loading,
        data_loadings,
        checkedList,
        export_visible,
        exportDate,
        dataList,
        dataList2,
        detail_data,
        news_imgs,
        page,
        page2,
        total,
        total2,
        edit_id,
        PositionList,
        isDo,
        edit_modal,
        edit_modal2,
        detail_visible,
        duration_modal,
        duration_id,
        indeterminate,
        teamList,
        checkAll,
        isCur,
        isCur2,
        selectedRowKeys,
        multiple_duration,
        submit_loading,
        record_modal,
        rtotal,
        record_loading,
        img_visible,
        rpage,
        imgUrl,
        recordList,
        repair_visible,
      } = this.state,
      rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys) => this.setData({ selectedRowKeys }),
      },
      columns = [
        {
          title: "创建日期",
          dataIndex: "work_create_time",
          key: "work_create_time",
          width: "15%",
        },
        {
          title: "队伍",
          dataIndex: "teamname",
          key: "teamname",
          width: "12%",
        },
        {
          title: "任务名称",
          dataIndex: "title",
          key: "title",
          width: "14%",
        },
        {
          title: "更改项目",
          dataIndex: "work_status",
          key: "work_status",
          width: "10%",
          render(status, { update_type }) {
            let text = "";
            if (status === "1") text = "添加";
            else if (status === "2") text = "编辑";
            return text + update_type;
          },
        },
        {
          title: "修改前",
          dataIndex: "work_before",
          key: "work_before",
          width: "12%",
        },
        {
          title: "修改后",
          dataIndex: "work_after",
          key: "work_after",
          width: "12%",
        },
        {
          title: "操作人",
          dataIndex: "vname",
          key: "vname",
          width: "10%",
        },
        {
          title: "编辑日期",
          dataIndex: "work_time",
          key: "work_time",
          width: "15%",
        },
      ],
      columns2 = [
        {
          title: "创建日期",
          dataIndex: "create_time",
          key: "create_time",
          width: "12%",
        },
        {
          title: "任务类型",
          dataIndex: "type_name",
          key: "type_name",
          width: "7%",
        },
        {
          title: "任务等级",
          dataIndex: "ally_grade",
          key: "ally_grade",
          width: "7%",
        },
        {
          title: "任务名称",
          dataIndex: "title",
          key: "title",
          width: "12%",
        },
        {
          title: "任务时间",
          dataIndex: "action_time",
          key: "action_time",
          width: "12%",
          render: (action_time, { recruit_time }) => {
            return (
              <div>
                <div>{action_time}</div>
                <div>{recruit_time}</div>
              </div>
            );
          },
        },
        {
          title: "发布状态",
          dataIndex: "publish_status",
          key: "publish_status",
          width: "10%",
          render: (publish_status, { publish_time, publish_name }) =>
            common.tableStatus(publish_status, publish_time, publish_name),
        },
        {
          title: "审核状态",
          dataIndex: "audit_status",
          key: "audit_status",
          width: "12%",
          render: (
            audit_status,
            { audit_name, audit_admin, audit_time, detail }
          ) =>
            common2.tableStatus(
              audit_status,
              audit_name,
              audit_admin,
              audit_time,
              detail
            ),
        },
        {
          title: "任务状态",
          dataIndex: "status_name",
          key: "status_name",
          width: "7%",
          render: (status_name, { status_colour }) => {
            return <span style={{ color: status_colour }}>{status_name}</span>;
          },
        },
        {
          title: "任务时长/人",
          dataIndex: "service_time",
          key: "service_time",
          width: "7%",
          render: (service_time) => service_time + " 小时" || " - ",
        },
        {
          title: "任务积分/人",
          dataIndex: "task_integral",
          key: "task_integral",
          width: "7%",
          render: (task_integral) => task_integral + " 分" || " - ",
        },
        {
          title: "报名人数(人)",
          dataIndex: "apply_number",
          key: "apply_number",
          width: "7%",
          render: (apply_number, { task_id }) => {
            return (
              <Tooltip title={"点击查看"}>
                <div
                  onClick={() => this.handleOpenEditModal2(task_id)}
                  style={{
                    fontSize: 16,
                    color: "#40a9ff",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {apply_number || " - "}
                </div>
              </Tooltip>
            );
          },
        },
        {
          title: "是否保密",
          dataIndex: "secret",
          key: "secret",
          width: "5%",
          render: (secret, { task_id }) => {
            // return <span>{secret == 0 ? "否" : "是"}</span>;
            return (
              <Switch
                checkedChildren="是"
                unCheckedChildren="否"
                defaultChecked={secret == 1}
                onClick={() => this.confidentiality(secret, task_id)}
              />
            );
          },
        },
        {
          title: "操作",
          dataIndex: "task_id",
          key: "task_id",
          width: "15%",
          render: (task_id, { task_status }) => {
            return (
              <div>
                {task_status == 0 ? (
                  <div>
                    <Button
                      size="small"
                      type="primary"
                      onClick={() => this.operation(task_id, 1)}
                    >
                      开始任务
                    </Button>
                  </div>
                ) : task_status == 1 ? (
                  <div>
                    <Button
                      size="small"
                      type="danger"
                      style={{
                        backgroundColor: "#ff4d4f",
                        color: "#f5f5f5",
                        border: "none",
                      }}
                      onClick={() => this.operation(task_id, 2)}
                    >
                      结束任务
                    </Button>
                  </div>
                ) : (
                  ""
                )}
                <div>
                  <Button
                    size="small"
                    type="primary"
                    style={{ marginTop: 10 }}
                    onClick={() => this.handleEdit(task_id, true)}
                  >
                    详情
                  </Button>
                </div>
                {task_status == 0 ? (
                  <div>
                    <Button
                      size="small"
                      type="primary"
                      style={{ marginTop: 10 }}
                      onClick={() => this.handleEdit(task_id, false)}
                    >
                      编辑
                    </Button>
                  </div>
                ) : null}
                {task_status == 0 ? (
                  <Popconfirm
                    placement="bottom"
                    title="确定删除吗？"
                    cancelText="取消"
                    okText="确定"
                    onConfirm={() => this.handleDelete(task_id)}
                  >
                    <div>
                      <Button
                        size="small"
                        type="danger"
                        style={{ marginTop: 10 }}
                      >
                        删除
                      </Button>
                    </div>
                  </Popconfirm>
                ) : null}
              </div>
            );
          },
        },
      ],
      columns3 = [
        {
          title: "队员姓名",
          dataIndex: "vname",
          key: " vname",
          width: "7%",
        },
        {
          title: "队员身份",
          dataIndex: "v_status_name",
          key: "v_status_name",
          width: "7%",
        },
        {
          title: "任务时长",
          dataIndex: "task_duration",
          key: "task_duration",
          width: "7%",
          render: (task_duration, { user_id }) => {
            return (
              <InputNumber
                disabled={isCur}
                step={0.5}
                min={0}
                precision={1} // 设置小数点位数为1
                defaultValue={parseFloat(task_duration)}
                onChange={(value) => this.handleSetEditList(user_id, value)}
              />
            );
          },
        },
        {
          title: "任务积分",
          dataIndex: "task_integral",
          key: "task_integral",
          width: "7%",
          render: (task_integral, { user_id }) => {
            return (
              <InputNumber
                step={1}
                min={0}
                precision={1}
                formatter={(value) => `${value}`}
                parser={(value) => Math.round(value)}
                disabled={isCur2}
                defaultValue={parseFloat(task_integral)}
                onChange={(value) => this.handleSetEditList(user_id, value)}
              />
            );
          },
        },
        {
          title: "报名时间",
          dataIndex: "apply_time",
          key: "apply_time",
          width: "10%",
        },
        {
          title: "打卡开始时间",
          dataIndex: "begin_time",
          key: "begin_time",
          width: "10%",
        },
        {
          title: "打卡结束时间",
          dataIndex: "end_time",
          key: "end_time",
          width: "10%",
        },
        {
          title: "任务状态",
          dataIndex: "status_name",
          key: "status_name",
          width: "7%",
          render: (status_name, { status_colour }) => {
            return (
              <span style={{ color: status_colour, fontWeight: "bold" }}>
                {status_name}
              </span>
            );
          },
        },
        {
          title: "操作",
          dataIndex: "record_id",
          key: "record_id",
          width: "12%",
          render: (record_id, { user_id }) => {
            return (
              <div>
                <Button
                  size="small"
                  type="primary"
                  style={{ marginTop: 10, marginRight: 10 }}
                  onClick={() => this.handleOpenDetail(record_id)}
                >
                  详情
                </Button>
                <Button
                  size="small"
                  type="primary"
                  style={{ marginTop: 10 }}
                  onClick={() => this.repair(user_id)}
                >
                  补卡
                </Button>
              </div>
            );
          },
        },
      ],
      columns4 = [
        {
          title: "姓名",
          dataIndex: "vname",
          key: "vname",
          width: "7%",
        },
        {
          title: "修改时间",
          dataIndex: "work_time",
          key: "work_time",
          width: "7%",
        },
        {
          title: "修改前",
          dataIndex: "work_before",
          key: "work_before",
          width: "7%",
        },
        {
          title: "修改后",
          dataIndex: "work_after",
          key: "work_after",
          width: "7%",
        },
        {
          title: "修改类型",
          dataIndex: "type_name",
          key: "type_name",
          width: "7%",
        },
        {
          title: "修改人",
          dataIndex: "work_vname",
          key: "work_vname",
          width: "7%",
        },
      ],
      formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
      exportNode = (
        <div>
          <div style={{ width: 800, height: 600, overflowY: "auto" }}>
            <div style={{ margin: "10px 0" }}>选择日期:</div>
            <div>
              <RangePicker
                value={exportDate}
                disabledDate={(current) =>
                  current && current > moment().endOf("day")
                }
                onChange={(datas) => this.setData({ exportDate: datas })}
              />
            </div>
            <div style={{ margin: "10px 0" }}>选择队伍:</div>
            <div>
              <Checkbox
                indeterminate={indeterminate}
                onChange={this.handleExportCheckAll}
                checked={checkAll}
              >
                全选
              </Checkbox>
              <Select
                style={{ width: "calc(100% - 100px)" }}
                mode="multiple"
                onChange={this.handleExportCheckChange}
                // onChange={handleChange}
              >
                {teamList.map((team, i) => {
                  return (
                    <Select.Option key={i} value={team.teamno}>
                      {team.teamname}
                    </Select.Option>
                  );
                })}
              </Select>
              <Divider style={{ margin: "8px 0" }} />
              <CheckboxGroup
                value={checkedList}
                onChange={this.handleExportCheckChange}
              >
                <Row>
                  {teamList.map((team, i) => {
                    return (
                      <Col span={8} key={i}>
                        <Checkbox value={team.teamno}>{team.teamname}</Checkbox>
                      </Col>
                    );
                  })}
                </Row>
              </CheckboxGroup>
            </div>
          </div>
          {"1".indexOf(app.getData("rights")) > -1 ? (
            <div
              style={{
                textAlign: "right",
                marginTop: 10,
                paddingTop: 12,
                borderTop: "1px solid #ddd",
              }}
            >
              <Button
                onClick={() => this.setData({ export_visible: false })}
                style={{ marginRight: 20 }}
              >
                取消
              </Button>
              <Button type="primary" onClick={this.handleExport}>
                确认导出
              </Button>
            </div>
          ) : null}
        </div>
      );
    function showTotal(total2) {
      return `总数：${total2}条`;
    }
    function showTotal1(total) {
      return `总数：${total}条`;
    }
    const handleCancel = () => {
      this.setData({ repair_visible: false });
    };
    const handleOk = async () => {
      let { task_id, userIds } = this.state,
        params = {
          task_id,
          user_id_str: userIds,
          account: app.getData("account"),
        };
      let { flag, msg } = await app.post(api.durationTaskReissue, params);
      if (flag !== 1) {
        app.alert(msg, "error");
      } else {
        app.alert(msg, "success");
        this.handleOpenEditModal2(task_id, 1);
      }
      this.setData({ repair_visible: false, selectedRowKeys: [] });
    };
    const maximg = (index) => {
      // 处理点击事件，放大图片
      this.setData({
        img_visible: true,
        imgUrl: news_imgs[index],
        currentIndex: index,
      });
    };
    //  上一张
    const handlePreviousImage = () => {
      let { currentIndex, news_imgs } = this.state;
      // 切换到上一张图片
      const previousIndex =
        currentIndex === 0 ? news_imgs.length - 1 : currentIndex - 1;
      maximg(previousIndex);
      this.setData({ currentIndex: previousIndex });
    };

    // 下一张

    const handleNextImage = () => {
      // 切换到下一张图片
      let { currentIndex, news_imgs } = this.state;
      const nextIndex =
        currentIndex === news_imgs.length - 1 ? 0 : currentIndex + 1;
      maximg(nextIndex);
      this.setData({ currentIndex: nextIndex });
    };
    return (
      <div className="sign-report" style={{padding:'20px 0'}}>
        <Row className="sr-content">
          <Col span={23} offset={1} className="src-infos">
            <Card
              width="100%"
              height="100%"
              style={{
                padding: 25,
                height: "calc(100% - 68px)",
                overflow: "auto",
              }}
              title={
                <Row type="flex" justify="space-between" align="middle">
                  <Col
                    style={{ display: "flex", justifyContent: "flex-end" }}
                    span={23}
                  >
                    <Button
                      type="primary"
                      onClick={() => this.handleOpenEditModal(select_team)}
                    >
                      发布多队任务
                    </Button>
                    <Button type="primary" style={{ marginLeft: 10 }}>
                      补录多队任务
                    </Button>
                  </Col>
                </Row>
              }
            >
              <Col
                style={{
                  display: "flex",
                  marginBottom: "10px",
                  width: "100%",
                  justifyContent: "space-around",
                }}
                span={23}
              >
                <div
                  style={{
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "70px" }}>任务时间： </div>
                  <DatePicker.RangePicker
                    style={{ width: "280px" }}
                    onChange={this.handleDateChange}
                    locale={date_locale}
                    format="YYYY年MM月DD日"
                    // disabledDate={(current) =>
                    //   current && current > moment().endOf("day")
                    // }
                  />
                </div>
                <div
                  style={{
                    marginRight: "15px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: 14, width: "70px" }}>任务类型 </span>
                  <Select
                    defaultValue="-1"
                    style={{ width: 120 }}
                    onChange={async (value) => {
                      await this.setData({ type: value });
                      await this.handleReportsData(select_team.team_id);
                    }}
                  >
                    <Option value="-1">全部</Option>
                    {PositionList.map((item, index) => (
                      <Option value={item.id}>{item.name}</Option>
                    ))}
                  </Select>
                </div>
                <div
                  style={{
                    marginRight: "15px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: 14, width: "70px" }}>发布状态 </span>
                  <Select
                    defaultValue="-1"
                    style={{ width: 120 }}
                    onChange={async (value) => {
                      await this.setData({ publish_status: value });
                      await this.handleReportsData(select_team.team_id);
                    }}
                  >
                    <Option value="-1">全部</Option>
                    <Option value="0">未发布</Option>
                    <Option value="1">已发布</Option>
                  </Select>
                </div>
                <Input.Group compact>
                  <Select
                    style={{ width: 100 }}
                    defaultValue="任务名称"
                    onChange={(e) => this.changeSelect(e)}
                  >
                    <Option value="任务名称">任务名称</Option>
                  </Select>
                  <Input.Search
                    onSearch={() => this.toSearchBtn()}
                    onChange={(e) => this.inputMotify(e)}
                    style={{ width: 240, marginRight: 10 }}
                    enterButton="搜索"
                  />
                </Input.Group>
              </Col>
              <Table
                style={{ marginTop: "40px" }}
                columns={select_tab === "2" ? columns2 : columns}
                locale={app.tbLocale(data_loading)}
                loading={data_loading}
                dataSource={dataList}
                size="small"
                className="srci-table"
                scroll={{ y: "calc(100vh - 450px)" }}
                pagination={false}
              />
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Pagination
                  style={{ marginTop: 16 }}
                  current={page}
                  defaultCurrent={1}
                  total={total}
                  showTotal={showTotal1}
                  defaultPageSize={20}
                  size="default"
                  onChange={(e) => this.changeAhegp(e)}
                />
              </div>
            </Card>
          </Col>
        </Row>
        <Modal
          visible={edit_modal}
          title={
            edit_id ? (edit_id && isDo ? "查看任务" : "编辑任务") : "发布任务"
          }
          onCancel={this.handleCloseEditModal}
          footer={null}
          maskClosable={false}
          destroyOnClose={true}
          width={1000}
          bodyStyle={{
            height: "calc(100vh - 100px)",
            overflowY: "auto",
            minHeight: 400,
            position: "relative",
          }}
          style={{ top: 20, paddingBottom: 20 }}
        >
          <TaskAdd
            edit_id={edit_id}
            select_team={select_team}
            isDo={isDo}
            type={"2"}
            onClose={this.handleCloseEditModal}
            onDuration={this.handleOpenDurationModal}
          />
        </Modal>
        <Modal
          visible={edit_modal2}
          title={"报名信息"}
          onCancel={this.handleCloseEditModal2}
          footer={null}
          width={1500}
          maskClosable={false}
          destroyOnClose={true}
          bodyStyle={{
            height: "calc(100vh - 300px)",
            overflowY: "auto",
            minHeight: 750,
            position: "relative",
          }}
          style={{ top: 20, paddingBottom: 20 }}
        >
          <Row style={{ marginBottom: 10 }}>
            <Col>
              <Button
                type="primary"
                style={{ marginRight: 10 }}
                onClick={() => this.amend_duration()}
              >
                修改时长
              </Button>
              <Button type="primary" onClick={() => this.amend_integral()}>
                修改积分
              </Button>
            </Col>
          </Row>
          <Table
            columns={columns3}
            locale={app.tbLocale(data_loadings)}
            loading={data_loadings}
            dataSource={dataList2}
            rowSelection={rowSelection}
            size="small"
            className="srci-table"
            scroll={{ y: "calc(100vh - 520px)" }}
            pagination={false}
            footer={() => {
              return (
                <Row type="flex" justify="space-between" align="middle">
                  <Col>
                    <Checkbox
                      checked={
                        dataList2.length !== 0 &&
                        dataList2.length === selectedRowKeys.length
                      }
                      onChange={this.handleAllSel}
                    >
                      全选
                    </Checkbox>
                    <InputNumber
                      style={{ marginLeft: 20 }}
                      min={0}
                      precision={1}
                      step={isCur == false ? 0.5 : 1}
                      parser={
                        isCur2 === false
                          ? (value) => Math.round(value)
                          : (value) => value
                      }
                      value={multiple_duration}
                      disabled={(isCur && isCur2) || selectedRowKeys.length < 1}
                      onChange={(value) => {
                        this.setData({ multiple_duration: value });
                      }}
                    />
                    <Button
                      type="primary"
                      style={{ marginLeft: 10 }}
                      disabled={
                        selectedRowKeys.length < 1 &&
                        multiple_duration &&
                        multiple_duration >= 0.5
                      }
                      onClick={() =>
                        this.handleMultipleSetEditList(
                          multiple_duration,
                          selectedRowKeys
                        )
                      }
                    >
                      确定
                    </Button>
                    <span
                      style={{
                        display: "inline-block",
                        color: "red",
                        marginLeft: 5,
                      }}
                    >
                      确定之后点击[保存]按钮
                    </span>
                    <Button
                      type="primary"
                      style={{ marginLeft: 20 }}
                      disabled={selectedRowKeys.length < 1}
                      onClick={() =>
                        this.handleMultipleSetEditList2(selectedRowKeys)
                      }
                    >
                      批量补卡
                    </Button>
                  </Col>
                </Row>
              );
            }}
          />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Pagination
              style={{ marginTop: 16 }}
              current={page2}
              defaultCurrent={1}
              total={total2}
              showTotal={showTotal}
              defaultPageSize={20}
              size="default"
              onChange={(e) => this.changeAhegp2(e)}
            />
          </div>
          <div style={{ color: "red", marginTop: 12 }}>
            注：批量修改，请先选择修改的类型，再输入修改数，然后点击确定(确定后可预览)，最后点击保存。
          </div>
          <Row
            style={{ paddingTop: 24 }}
            type="flex"
            justify="space-between"
            align="middle"
          >
            <Col>
              <Button type="primary" onClick={this.handleOpenRecord}>
                修改记录
              </Button>
            </Col>
            <Col>
              <Button onClick={this.handleCloseEditModal2}>取消</Button>
              <Button
                type="primary"
                onClick={this.handleConfirm}
                style={{ marginLeft: 20 }}
                loading={submit_loading}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Modal>
        <Modal
          visible={detail_visible}
          footer={null}
          title="报名信息详情"
          maskClosable={false}
          width={1000}
          destroyOnClose={true}
          bodyStyle={{
            height: "calc(100vh - 100px)",
            overflowY: "auto",
            minHeight: 400,
            position: "relative",
          }}
          style={{ top: 20, paddingBottom: 20 }}
          onCancel={this.handleCancelDetail}
          className="news-detail-modal-class"
        >
          <Form>
            <FormItem
              label="任务记录状态"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              <span
                style={{ color: detail_data.status_colour, fontWeight: "bold" }}
              >
                {" "}
                {detail_data.status_name}
              </span>
            </FormItem>
            <FormItem
              label="报名时间"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              {detail_data.apply_time}
            </FormItem>
            <FormItem
              label="打卡开始时间"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              {detail_data.begin_time}
            </FormItem>
            <FormItem
              label="结束打开时间"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              {detail_data.end_time}
            </FormItem>
            <FormItem
              label="任务时长"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              {detail_data.task_duration} 小时
            </FormItem>
            <FormItem
              label="任务积分"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              {detail_data.task_integral} 分
            </FormItem>
            <FormItem
              label="打卡位置"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              {detail_data.live_location}
            </FormItem>
            <FormItem
              label="现场图片"
              {...formItemLayout}
              style={{ margin: "0 0 10px" }}
            >
              {news_imgs.map((imageUrl, index) => (
                <img
                  key={index}
                  style={{
                    width: "100px",
                    height: "100px",
                    margin: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => maximg(index)}
                  src={config.imgUrl + imageUrl}
                />
              ))}
            </FormItem>
            <FormItem
              label="现场描述"
              {...formItemLayout}
              style={{ margin: " 0 0 10px" }}
            >
              {detail_data.live_remark}
            </FormItem>
          </Form>
        </Modal>
        <Modal
          visible={record_modal}
          title="修改记录"
          footer={null}
          width={800}
          zIndex={1002}
          maskClosable={false}
          destroyOnClose={true}
          onCancel={this.handleCloseRecord}
          bodyStyle={{ height: "calc(100vh - 100px)" }}
          style={{ paddingBottom: 0, top: 20 }}
        >
          <div style={{ marginRight: "20px", width: "430px", marginBottom: 5 }}>
            <span>修改类型 </span>
            <Select
              defaultValue="-1"
              style={{ width: 120 }}
              onChange={async (value) => {
                await this.setData({ edit_type: value });
                await this.handleRecordData();
              }}
            >
              <Option value="-1">全部</Option>
              <Option value="1">时长</Option>
              <Option value="2">积分</Option>
            </Select>
          </div>
          <Table
            columns={columns4}
            locale={app.tbLocale(record_loading)}
            loading={record_loading}
            dataSource={recordList}
            size="small"
            scroll={{ y: "calc(100vh - 250px)" }}
            width={800}
            className="report-dration-table"
            pagination={{
              total: rtotal,
              pageSize: 20,
              current: rpage,
              showTotal: (total) => `总数量：${total}`,
              onChange: this.handleRecordData,
            }}
            footer={null}
          />
        </Modal>
        <Modal visible={repair_visible} onOk={handleOk} onCancel={handleCancel}>
          <h3 style={{ color: "#000", textAlign: "center" }}>
            补卡成功队员可获得相应任务时长和积分
          </h3>
          <p style={{ textAlign: "center", color: "red", fontSize: 14 }}>
            确认补卡吗?
          </p>
        </Modal>
        <Modal
          visible={img_visible}
          footer={null}
          maskClosable={false}
          destroyOnClose={true}
          width={1400}
          bodyStyle={{
            backgroundColor: " rgba(0,0,0,.65)",
            height: "calc(100vh - 100px)",
            overflowY: "auto",
            minHeight: 430,
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          style={{ top: 20, paddingBottom: 20 }}
          onCancel={this.handleCancelDetails}
          zIndex={1010}
          className="news-detail-modal-class"
        >
          <img width="95%" height="95%" src={config.imgUrl + imgUrl} />
          <div style={{ marginTop: 5 }}>
            <Button
              style={{ margin: "0 20px" }}
              type="primary"
              onClick={() => handleNextImage()}
            >
              上一张
            </Button>
            <Button
              style={{ margin: "0 20px" }}
              type="primary"
              onClick={() => handlePreviousImage()}
            >
              下一张
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default SignReport;



// WEBPACK FOOTER //
// ./src/routes/sign/SignReport2.jsx